import { useState } from 'react';

export function useSearchFieldStates() {
  const [employee, setEmployee] = useState<BanHangRecord>(null);
  const [customer, setCustomer] = useState<BanHangRecord>(null);
  const [customerGroup1, setCustomerGroup1] = useState<BanHangRecord>(null);
  const [customerGroup2, setCustomerGroup2] = useState<BanHangRecord>(null);
  const [customerGroup3, setCustomerGroup3] = useState<BanHangRecord>(null);
  const [region, setRegion] = useState<BanHangRecord>(null);
  const [product, setProduct] = useState<BanHangRecord>(null);
  const [productGroup1, setProductGroup1] = useState<BanHangRecord>(null);
  const [productGroup2, setProductGroup2] = useState<BanHangRecord>(null);
  const [productGroup3, setProductGroup3] = useState<BanHangRecord>(null);
  const [warehouse, setWarehouse] = useState<BanHangRecord>(null);

  const [transaction, setTransaction] = useState<BanHangRecord>(null);
  const [itemAccount, setItemAccount] = useState<BanHangRecord>(null);
  const [revenueAccount, setRevenueAccount] = useState<BanHangRecord>(null);
  const [costAccount, setCostAccount] = useState<BanHangRecord>(null);
  const [batch, setBatch] = useState<BanHangRecord>(null);
  const [location, setLocation] = useState<BanHangRecord>(null);

  const getSearchFieldData = () => {
    return {
      ma_nvbh: employee?.uuid || '',
      ma_kh: customer?.uuid || '',
      nh_kh1: customerGroup1?.uuid || '',
      nh_kh2: customerGroup2?.uuid || '',
      nh_kh3: customerGroup3?.uuid || '',
      rg_code: region?.uuid || '',
      ma_vt: product?.uuid || '',
      nh_vt1: productGroup1?.uuid || '',
      nh_vt2: productGroup2?.uuid || '',
      nh_vt3: productGroup3?.uuid || '',
      ma_kho: warehouse?.uuid || '',

      ma_gd: transaction?.uuid || '',
      tk_vt: itemAccount?.uuid || '',
      tk_dt: revenueAccount?.uuid || '',
      tk_gv: costAccount?.uuid || '',
      ma_lo: batch?.uuid || '',
      ma_vi_tri: location?.uuid || ''
    };
  };

  return {
    employee,
    setEmployee,
    customer,
    setCustomer,
    customerGroup1,
    setCustomerGroup1,
    customerGroup2,
    setCustomerGroup2,
    customerGroup3,
    setCustomerGroup3,
    region,
    setRegion,
    product,
    setProduct,
    productGroup1,
    setProductGroup1,
    productGroup2,
    setProductGroup2,
    productGroup3,
    setProductGroup3,
    warehouse,
    setWarehouse,

    transaction,
    setTransaction,
    itemAccount,
    setItemAccount,
    revenueAccount,
    setRevenueAccount,
    costAccount,
    setCostAccount,
    batch,
    setBatch,
    location,
    setLocation,

    getSearchFieldData
  };
}
